import {
  prop,
  propEq,
  converge,
  includes,
  compose,
  nthArg,
  find,
  pluck,
  join,
} from 'ramda';

import { watchlist } from 'app/features/watchlist/selectors';

const series = prop('series');

const seriesIdFromProps = compose(prop('seriesId'), nthArg(1));

const byPropsId = compose(propEq('id'), nthArg(1));

const mediaByPropsId = converge(find, [byPropsId, series]);

const seriesIdJoined = compose(join(','), pluck(['id']));

const seriesIds = compose(seriesIdJoined, series);

const isSeriesInWatchlist = converge(includes, [seriesIdFromProps, watchlist]);

export { series, isSeriesInWatchlist, mediaByPropsId, seriesIds };
